import { render, staticRenderFns } from "./ApplicantFormKorolev.vue?vue&type=template&id=1b7fbe23&scoped=true&"
import script from "./ApplicantFormKorolev.vue?vue&type=script&lang=js&"
export * from "./ApplicantFormKorolev.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantFormKorolev.vue?vue&type=style&index=0&id=1b7fbe23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7fbe23",
  null
  
)

export default component.exports